import { z } from 'zod';
export var Commission = z.object({
  commissionRate: z.number()
});
export var CommissionResponse = z.object({
  attributes: z.object({}).passthrough(),
  type: z.literal('application_commission')
});
export var CommissionHistoryItem = z.object({
  id: z.string(),
  commissionRate: z.number(),
  comment: z.string().nullish(),
  createdAt: z.string()
});
export var CommissionTransaction = z.object({
  currency: z.string(),
  currencySymbol: z.string(),
  dateOfTransaction: z.string(),
  total: z.number(),
  transactionNote: z.string().nullish()
});
export var CommissionTransactionResponse = z.object({
  attributes: z.object({}).passthrough(),
  type: z.literal('application_transaction')
});